import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
} from '@angular/core';
import {
    IRole,
    ModalResultType,
} from '@models';
import {
    GRID_SERVICE,
    ODataGridComponent,
    STATE_HANDLER,
    urlStateHandler,
} from '@pages/generics/grid';
import { RoleService } from '@services';

import cloneDeep from 'lodash-es/cloneDeep';

import {
    RoleModalComponent,
    RoleUsersModalComponent,
} from './modals';

@Component({
    templateUrl: './roles.page.html',
    providers: [{
        provide: GRID_SERVICE,
        useClass: RoleService,
    },
    {
        provide: STATE_HANDLER,
        useValue: urlStateHandler,
    }],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RolesPageComponent extends ODataGridComponent<IRole, number> implements OnInit {
    public openModal(model?: IRole) {
        let clone: IRole | undefined;
        if (model) {
            clone = cloneDeep(model);
        }

        this._modal
            .openModal(RoleModalComponent, clone)
            .afterClosedResult()
            .subscribe(res => {
                switch (res.type) {
                    case ModalResultType.Add:
                        // open the manage users modal
                        this.openUsersModal(res.data);
                        this._refresh$.next();
                        break;
                    case ModalResultType.Update:
                        this._refresh$.next();
                        break;
                }
            });
    }

    public openUsersModal(model?: IRole) {
        const clone = cloneDeep(model);
        this._modal.openModal(RoleUsersModalComponent, clone);
    }


    ngOnInit() {
        this._expand$.next(['Permissions']);
    }

    public get allowDelete(): boolean {
        return this._grid.selectionManager.hasValue() &&
            this._grid.selectionManager.selected.every((r) => r.isStatic === false);
    }
}
